const jiraConfigMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'workspace url',
        label: 'Workspace URL',
        'min-width': 100,
        name: "workspace_url",
        sortable: false
      },
      {
        datatype: 'string',
        description: 'email',
        label: 'Email',
        'min-width': 100,
        name: 'email_id',
        sortable: false
      },
      {
        datatype: 'string',
        description: 'token',
        label: 'Token',
        'min-width': 100,
        name: 'api_token',
        sortable: false
      },
      {
        datatype: 'string',
        description: 'project',
        label: 'Project',
        'min-width': 100,
        name: 'project_id',
        sortable: false
      }
    ]
  }
}

export { jiraConfigMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/jira/jira-config-meta.js